import { ActivatedRoute, Router } from '@angular/router';
import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription, zip } from 'rxjs';
import { tap } from 'rxjs/operators';
import * as FileSaver from 'file-saver';

import {
    AcceptOrderSignatoriesUseCase,
    BaseProductInterface,
    ClientInterface,
    ContinueOrderSignUseCase,
    ContractInterface,
    CreateOperationUseCase,
    GetAppropriatenessClientUseCase,
    GetDocumentContentUseCase,
    GetMyProductsUseCase,
    GetOrderDocumentsUseCase,
    GetSelectedProductsUseCase,
    IdInterface,
    MifidCategoryCode,
    OrderClientInterface,
    OrderDocumentInterface,
    RememberOrderUseCase,
    RemoveDocumentUseCase,
    RemoveSelectedProductsUseCase,
    SelectedProductInterface,
    SelectedProductStatus,
    UpdateSelectedProductsUseCase,
    UploadOrderDocumentsUseCase,
    UserInterface,
    AddSelectedProductsUseCase,
    GetOperationUseCase,
    OrderType,
    OperationInterface,
    UpdateOperationUseCase,
    GetProductsByOrderTypeUseCase,
    GetProductsByOrderTypeClientUseCase,
    LegalGuardianType,
    Nature,
} from '../../../../core';
import { AppConfig } from '../../../utils/app-config.service';
import { BasePage } from '../../base.page';
import { ConfirmDialog } from '../../../ui/dialog/confirm/confirm.dialog';
import { CreateRefundOperationUseCase } from '../../../usecases/create-refund-operation.use-case';
import { ErrorDialog } from '../../../ui/dialog/error/error.dialog';
import { Id, Product } from '../../../domain/data';
import { Loader } from '../../../client/helpers/loader';
import { LocalStorage } from '../../../client/helpers/local-storage';
import { MainRoutes } from '../../../main-routes.enum';
import { OperativePage } from '../operative.page';
import { ParentEvents } from '../../../utils/parent-events.service';

import { environment } from '../../../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Component({
    templateUrl: './operative-list.page.html',
    styleUrls: ['./operative-list.page.scss'],
})
export class OperativeListPage extends BasePage implements AfterViewInit, OnDestroy, OnInit {
    public rol: string;
    public OrderType: typeof OrderType = OrderType;
    public MifidCategoryCode: typeof MifidCategoryCode = MifidCategoryCode;
    public appropriatenessClient: ClientInterface;
    public defaultSection: string;
    public isExpiredDoc = false;
    public isExpiredTest = false;
    public ordersDraft: BaseProductInterface[] = [];
    public ordersPending: SelectedProductInterface[] = [];
    public ordersCanceled: SelectedProductInterface[] = [];
    public ordersPeriod: SelectedProductInterface[] = [];
    public ordersBorrador: BaseProductInterface[] = [];
    private readonly backSubscription: Subscription;
    public isValidator: boolean = undefined;

    @ViewChild('formLogalty')
    public formLogalty: ElementRef;
    public formLogaltyAction: string = AppConfig.settings.logaltyUrl;
    public formLogaltyXml: string;
    public isClientPortal = environment.portalClient;

    public arrTypes = [];
    public arrFunds = [];

    public selectedType: any;
    public selectedTypeValue: string;
    public selectedFund: any;
    public selectedFundValue: string;
    public selectedProduct: any;
    public currentOperation: OperationInterface;
    public fundsplaceholder = 'Seleccione uno de los fondos';

    constructor(
        parentEvents: ParentEvents,
        private readonly operativePage: OperativePage,
        private readonly acceptOrderSignatoriesUseCase: AcceptOrderSignatoriesUseCase,
        private readonly activatedRoute: ActivatedRoute,
        private readonly continueOrderSignUseCase: ContinueOrderSignUseCase,
        private readonly createOperationUseCase: CreateOperationUseCase,
        private readonly createRefundOperationUseCase: CreateRefundOperationUseCase,
        private readonly dialog: MatDialog,
        private readonly getAppropriatenessClientUseCase: GetAppropriatenessClientUseCase,
        private readonly getDocumentContentUseCase: GetDocumentContentUseCase,
        private readonly getMyProductsUseCase: GetMyProductsUseCase,
        private readonly getOrderDocumentsUseCase: GetOrderDocumentsUseCase,
        private readonly getSelectedProductsUseCase: GetSelectedProductsUseCase,
        private readonly loader: Loader,
        private readonly localStorage: LocalStorage,
        private readonly rememberOrderUseCase: RememberOrderUseCase,
        private readonly removeDocumentUseCase: RemoveDocumentUseCase,
        private readonly removeSelectedProductsUseCase: RemoveSelectedProductsUseCase,
        private readonly renderer: Renderer2,
        private readonly router: Router,
        private readonly updateSelectedProductsUseCase: UpdateSelectedProductsUseCase,
        private readonly uploadOrderDocumentsUseCase: UploadOrderDocumentsUseCase,
        private readonly getOperationUseCase: GetOperationUseCase,
        private readonly updateOperationUseCase: UpdateOperationUseCase,
        private readonly getProductsByOrderTypeUseCase: GetProductsByOrderTypeUseCase,
        private readonly getProductsByOrderTypeClientUseCase: GetProductsByOrderTypeClientUseCase,
        private readonly addSelectedProductsUseCase: AddSelectedProductsUseCase,
        private readonly translate: TranslateService
    ) {
        super(parentEvents);
        if (this.isClientPortal) {
            this.operativePage.showBackButton();
            this.backSubscription = operativePage.back.subscribe(() => {
                this.parentEvents.cancel();
            });
        } else {
            this.operativePage.hideBackButton();
        }
    }

    get user(): UserInterface {
        return this.operativePage.user;
    }

    get contract(): ContractInterface {
        return this.operativePage.contract;
    }

    ngOnInit() {
        if (localStorage.getItem('RolName') == 'Validador') {
            this.isValidator = true;
        } else {
            this.isValidator = false;
        }

        this.isExpiredDoc = this.localStorage.isExpiredDoc;
        this.isExpiredTest = this.localStorage.isExpiredTest;

        this.defaultSection = 'orderTypes';
        this.renderer.addClass(document.body, 'bg-blue-gradient');
        this.operativePage.contractLoaded.subscribe((loaded) => {
            if (loaded) {
                localStorage.setItem('advisoryModel', this.contract.advisoryModel);

                if (this.contract) {
                    if (this.isExpiredDoc || this.isExpiredTest) {
                        this.arrTypes = [
                            { type: 'R', available: true },
                            { type: 'RP', available: true },
                        ];
                    } else {
                        this.arrTypes = [
                            { type: 'S', available: true },
                            { type: 'SP', available: true },
                            { type: 'R', available: true },
                            { type: 'RP', available: true },
                        ];

                        if (this.user) {
                            if (
                                this.isClientPortal &&
                                this.user.allowTransfers &&
                                !this.existApoderado(this.contract.authorized) &&
                                !this.existApoderadoInHolders(this.contract.holders) &&
                                !this.existAnyNoResident(this.contract.holders)
                            ) {
                                this.arrTypes.push({ type: 'I', available: true });
                                this.arrTypes.push({ type: 'E', available: true });
                            } else if (!this.isClientPortal) {
                                if (
                                    !this.existApoderado(this.contract.authorized) &&
                                    !this.existApoderadoInHolders(this.contract.holders) &&
                                    !this.existAnyNoResident(this.contract.holders)
                                ) {
                                    this.arrTypes.push({ type: 'I', available: true });
                                    this.arrTypes.push({ type: 'E', available: true });
                                }
                            }
                        }
                    }
                }

                if (this.contract.isAdvisoryModelSuitabilityOrGDC()) {
                    this.getMyProducts();
                }

                this.getSelectedProducts();
                this.getOperation();
            }
        });

        this.activatedRoute.queryParams.subscribe((params) => {
            if ('section' in params) {
                this.defaultSection = params.section;
            }
        });
    }

    private existApoderado(authorized: ClientInterface[]): boolean {
        if (!authorized || authorized.length === 0) {
            return false;
        }

        return authorized.some((client) => client.legalGuardianType === LegalGuardianType.ATTORNEY_IN_FACT);
    }

    private existApoderadoInHolders(holders: ClientInterface[]): boolean {
        if (!holders || holders.length === 0) {
            return false;
        }

        return holders.some((client) => client.nature === Nature.COMPANY);
    }

    private existAnyNoResident(holders: ClientInterface[]): boolean {
        if (!holders || holders.length === 0) {
            return false;
        }

        return holders.some((client) => !client.isResident);
    }

    onSubmit() {}

    private getDistributionChannel() {
        let distributionChannel = [
            'Comercialización agente',
            'Comercialización agente + Comercialización web',
            'Comercialización agente + Asesoramiento',
            'Comercialización agente + Comercialización web + Asesoramiento',
        ];

        if (environment.portalClient) {
            distributionChannel = [
                'Comercialización web',
                'Comercialización agente + Comercialización web',
                'Comercialización web + Asesoramiento',
                'Comercialización agente + Comercialización web + Asesoramiento',
            ];
        }

        return distributionChannel;
    }

    onChangeOrderType(e) {
        this.selectedType = this.arrTypes.find((type) => type.type === e.value);
        this.fundsplaceholder = '';
        this.selectedFundValue = '';

        if (e.value == this.OrderType.INTERNAL_TRANSFER || e.value == this.OrderType.EXTERNAL_TRANSFER) {
            this.fundsplaceholder = this.translate.instant('form.select-target-fund'); //"Seleccione el fondo destino";
        } else {
            this.fundsplaceholder = this.translate.instant('form.select-a-funds'); //"Seleccione uno de los fondos"
        }

        if (this.isClientPortal) {
            //ESto a cambiar onboardingclient/get_productsbyordertype

            this.getProductsByOrderTypeClientUseCase
                .bind({
                    portfolioCode: Id.fromString(this.localStorage.contractCode),
                    clientCode: Id.fromString(this.localStorage.clientCode),
                    distributionChannel: this.getDistributionChannel(),
                    orderType: e.value,
                    riskLevel: '',
                })
                .subscribe((transaction) => {
                    this.ordersDraft = [];

                    transaction.fold(
                        (data) => (this.arrFunds = data),
                        (throwable) =>
                            this.dialog.open(ErrorDialog, {
                                data: { text: throwable.message },
                            })
                    );
                });
        } else {
            this.getProductsByOrderTypeUseCase
                .bind({
                    portfolioCode: Id.fromString(this.localStorage.contractCode),
                    clientCode: Id.fromString(this.localStorage.clientCode),
                    distributionChannel: this.getDistributionChannel(),
                    orderType: e.value,
                    riskLevel: '',
                })
                .subscribe((transaction) => {
                    this.ordersDraft = [];

                    transaction.fold(
                        (data) => (this.arrFunds = data),
                        (throwable) =>
                            this.dialog.open(ErrorDialog, {
                                data: { text: throwable.message },
                            })
                    );
                });
        }
    }

    onChangeFund(e) {
        this.selectedFund = this.arrFunds.find((product) => product.encryptedCode.value === e.value);
    }

    private getOperation() {
        this.getOperationUseCase.bind().subscribe((transaction) => {
            transaction.fold(
                (operation) => {
                    this.currentOperation = operation;
                    this.selectedFundValue = operation.selectedProduct.encryptedCode.value;
                    this.selectedTypeValue = operation.selectedProduct.order.type;

                    this.selectedType = this.arrTypes.find((type) => type.type === this.selectedTypeValue);

                    if (this.isClientPortal) {
                        this.getProductsByOrderTypeClientUseCase
                            .bind({
                                portfolioCode: Id.fromString(this.localStorage.contractCode),
                                clientCode: Id.fromString(this.localStorage.clientCode),
                                distributionChannel: this.getDistributionChannel(),
                                orderType: this.selectedType.type,
                                riskLevel: '',
                            })
                            .subscribe((transaction) => {
                                this.ordersDraft = [];
                                transaction.fold(
                                    (data) => {
                                        this.arrFunds = data;
                                        this.selectedFund = this.arrFunds.find(
                                            (product) => product.encryptedCode.value === this.selectedFundValue
                                        );
                                    },
                                    (throwable) =>
                                        this.dialog.open(ErrorDialog, {
                                            data: { text: throwable.message },
                                        })
                                );
                            });
                    } else {
                        this.getProductsByOrderTypeUseCase
                            .bind({
                                portfolioCode: Id.fromString(this.localStorage.contractCode),
                                clientCode: Id.fromString(this.localStorage.clientCode),
                                distributionChannel: this.getDistributionChannel(),
                                orderType: this.selectedType.type,
                                riskLevel: '',
                            })
                            .subscribe((transaction) => {
                                this.ordersDraft = [];
                                transaction.fold(
                                    (data) => {
                                        this.arrFunds = data;
                                        this.selectedFund = this.arrFunds.find(
                                            (product) => product.encryptedCode.value === this.selectedFundValue
                                        );
                                    },
                                    (throwable) =>
                                        this.dialog.open(ErrorDialog, {
                                            data: { text: throwable.message },
                                        })
                                );
                            });
                    }
                },
                (throwable) => {
                    /*this.router.navigateByUrl(MainRoutes.OPERATIVE_LIST);
                    this.dialog.open(ErrorDialog, {
                        data: { text: throwable.message },
                    });*/
                }
            );
        });
    }

    private getMyProducts() {
        this.getMyProductsUseCase.bind().subscribe((transaction) => {
            this.ordersDraft = [];

            transaction.fold(
                (products) => products.forEach((product) => this.ordersDraft.push(product)),
                (throwable) =>
                    this.dialog.open(ErrorDialog, {
                        data: { text: throwable.message },
                    })
            );
        });
    }

    private getSelectedProducts() {
        zip(
            this.getAppropriatenessClientUseCase.bind().pipe(
                tap((transaction) => {
                    if (transaction.isSuccess) {
                        this.appropriatenessClient = transaction.data;
                    }
                })
            ),
            this.getSelectedProductsUseCase
                .bind({
                    clientCode: Id.fromString(this.localStorage.clientCode),
                })
                .pipe(
                    tap((transaction) => {
                        if (!this.contract.isAdvisoryModelSuitabilityOrGDC()) {
                            this.ordersDraft = [];
                        }
                        this.ordersBorrador = [];
                        this.ordersCanceled = [];
                        this.ordersPending = [];
                        this.ordersPeriod = [];

                        transaction.fold(
                            (products) =>
                                products.forEach((product) => {
                                    switch (product.status) {
                                        case SelectedProductStatus.DRAFT:
                                            if (!this.contract.isAdvisoryModelSuitability()) {
                                                this.ordersDraft.push(product);
                                            }

                                            this.ordersBorrador.push(product);
                                            break;
                                        case SelectedProductStatus.CANCELED:
                                        case SelectedProductStatus.ERROR:
                                        case SelectedProductStatus.NON_SUCCESSFUL_SIGNATURE:
                                        case SelectedProductStatus.REJECTED:
                                        case SelectedProductStatus.EXPIRED:
                                            this.ordersCanceled.push(product);
                                            break;
                                        case SelectedProductStatus.ACCEPTED:
                                        case SelectedProductStatus.FOR_SIGNING:
                                        case SelectedProductStatus.IN_PROCESS:
                                            this.ordersPending.push(product);
                                            break;
                                        case SelectedProductStatus.ACTIVE:
                                            if (product.isSubscriptionActive()) {
                                                this.ordersPeriod.push(product);
                                            }
                                    }
                                }),
                            (throwable) =>
                                this.dialog.open(ErrorDialog, {
                                    data: { text: throwable.message },
                                })
                        );
                    })
                )
        ).subscribe({
            complete: () => {
                if (
                    this.ordersDraft.length === 0 &&
                    this.ordersPending.length === 0 &&
                    this.ordersCanceled.length === 0 &&
                    this.ordersPeriod.length === 0
                ) {
                    this.renderer.addClass(document.body, 'bg-blue-gradient');
                } else {
                    this.renderer.removeClass(document.body, 'bg-blue-gradient');
                }
            },
        });
    }

    ngOnDestroy() {
        if (this.backSubscription) {
            this.backSubscription.unsubscribe();
        }
        this.renderer.removeClass(document.body, 'bg-blue-gradient');
    }

    onAddMyProducts() {
        this.router.navigateByUrl(MainRoutes.OPERATIVE_MY_PRODUCTS);
    }

    onAddProducts() {
        this.router.navigateByUrl(MainRoutes.OPERATIVE_PRODUCTS);
    }

    onAccordionChange() {
        this.parentEvents.resize();
    }

    onDetail(code: IdInterface) {
        this.localStorage.step = 99;
        this.localStorage.write();

        window.open(MainRoutes.OPERATIVE_PRODUCTS_DETAIL.replace(':id', encodeURIComponent(String(code))), '_blank');
    }

    onRefund(product: BaseProductInterface) {
        this.createRefundOperationUseCase
            .bind({
                productCode: product.encryptedCode,
                clientCode: Id.fromString(this.localStorage.clientCode),
            })
            .subscribe((transaction) => {
                transaction.fold(
                    (_) => this.router.navigateByUrl(MainRoutes.OPERATIVE_OPERATE),
                    (throwable) =>
                        this.dialog.open(ErrorDialog, {
                            data: { text: throwable.message },
                        })
                );
            });
    }

    onRemove(product: BaseProductInterface) {
        this.removeSelectedProductsUseCase.bind({ product: product as SelectedProductInterface }).subscribe((transaction) => {
            if (transaction.isSuccess) {
                this.getSelectedProducts();
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog, {
                    data: { text: transaction.error },
                });
            }
        });
    }

    onExonerate(product: BaseProductInterface) {
        this.updateSelectedProductsUseCase.bind({ products: [product as SelectedProductInterface] }).subscribe((transaction) => {
            if (!transaction.isSuccess) {
                product.isExonerated = !product.isExonerated;
            }

            if (!transaction.isSuccess && !transaction.isAuthError) {
                this.dialog.open(ErrorDialog, {
                    data: { text: transaction.error },
                });
            }
        });
    }

    onOperate(e, onlyRefund = false) {
        this.ordersBorrador.forEach((p) => {
            this.onRemove(p);
        });

        let products: Product[] = [];
        products.push(this.selectedFund);

        this.addSelectedProductsUseCase
            .bind({
                products,
                check: false,
                clientCode: Id.fromString(this.localStorage.clientCode),
            })
            .subscribe((transaction) => {
                if (transaction.isSuccess) {
                    this.getSelectedProductsUseCase
                        .bind({
                            clientCode: Id.fromString(this.localStorage.clientCode),
                        })
                        .pipe(
                            tap((transaction) => {
                                transaction.fold(
                                    (products) =>
                                        products.forEach((product) => {
                                            if (
                                                product.encryptedCode.value === this.selectedFund.encryptedCode.value &&
                                                product.status === 'DRAFT'
                                            ) {
                                                this.selectedProduct = product;
                                            }
                                        }),
                                    (throwable) =>
                                        this.dialog.open(ErrorDialog, {
                                            data: { text: throwable.message },
                                        })
                                );
                            })
                        )
                        .subscribe((transaction) => {
                            if (transaction.isSuccess) {
                                this.createOperationUseCase
                                    .bind({
                                        selectedProductId: this.selectedProduct.id,
                                        readonly: false,
                                        clientCode: Id.fromString(this.localStorage.clientCode),
                                    })
                                    .subscribe((transaction) => {
                                        if (transaction.isSuccess) {
                                            this.getOperationUseCase.bind().subscribe((transaction) => {
                                                transaction.fold(
                                                    (operation) => {
                                                        this.currentOperation = operation;
                                                        this.currentOperation.selectedProduct.order.type = this.selectedType.type;

                                                        if (this.selectedType.type === 'I') {
                                                            this.currentOperation.selectedProduct.order.internalTransferCode =
                                                                this.currentOperation.selectedProduct.code.value;
                                                        }

                                                        this.updateOperationUseCase
                                                            .bind({
                                                                selectedProduct: this.currentOperation.selectedProduct,
                                                                clientCode: Id.fromString(this.localStorage.clientCode),
                                                            })
                                                            .subscribe((transaction) => {
                                                                transaction.fold(
                                                                    () => {
                                                                        this.router.navigateByUrl(MainRoutes.OPERATIVE_OPERATE);
                                                                    },
                                                                    (throwable) =>
                                                                        this.dialog.open(ErrorDialog, {
                                                                            data: { text: throwable.message },
                                                                        })
                                                                );
                                                            });
                                                    },
                                                    (throwable) => {
                                                        this.router.navigateByUrl(MainRoutes.OPERATIVE_LIST);
                                                        this.dialog.open(ErrorDialog, {
                                                            data: { text: throwable.message },
                                                        });
                                                    }
                                                );
                                            });
                                        } else if (!transaction.isAuthError) {
                                            this.dialog.open(ErrorDialog, {
                                                data: { text: transaction.error },
                                            });
                                        }
                                    });
                            }
                        });
                }
            });
    }

    onOrderDetail(code: Id) {
        this.createOperationUseCase
            .bind({
                selectedProductId: code,
                readonly: true,
                clientCode: Id.fromString(this.localStorage.clientCode),
            })
            .subscribe((transaction) => {
                if (transaction.isSuccess) {
                    this.router.navigateByUrl(MainRoutes.OPERATIVE_OPERATE);
                } else if (!transaction.isAuthError) {
                    this.dialog.open(ErrorDialog, {
                        data: { text: transaction.error },
                    });
                }
            });
    }

    onOrderEdit(code: Id) {
        this.createOperationUseCase
            .bind({
                selectedProductId: code,
                editing: true,
                clientCode: Id.fromString(this.localStorage.clientCode),
            })
            .subscribe((transaction) => {
                if (transaction.isSuccess) {
                    this.router.navigateByUrl(MainRoutes.OPERATIVE_OPERATE);
                } else if (!transaction.isAuthError) {
                    this.dialog.open(ErrorDialog, {
                        data: { text: transaction.error },
                    });
                }
            });
    }

    onOrderCancelPeriod(code: Id) {
        this.dialog
            .open(ConfirmDialog, {
                data: { text: 'dialog.cancel-period' },
            })
            .afterClosed()
            .subscribe((result) => {
                if (result) {
                    this.createOperationUseCase
                        .bind({
                            selectedProductId: code,
                            readonly: true,
                            clientCode: Id.fromString(this.localStorage.clientCode),
                        })
                        .subscribe((transaction) => {
                            if (transaction.isSuccess) {
                                this.router.navigateByUrl(MainRoutes.OPERATIVE_SIGN + '?cancel=1');
                            } else if (!transaction.isAuthError) {
                                this.dialog.open(ErrorDialog, {
                                    data: { text: transaction.error },
                                });
                            }
                        });
                }
            });
    }

    onOrderDownload(product: SelectedProductInterface) {
        this.getOrderDocumentsUseCase.bind({ product }).subscribe((transaction) => {
            if (transaction.isSuccess) {
                FileSaver.saveAs(transaction.data, 'download.zip');
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog, {
                    data: { text: transaction.error },
                });
            }
        });
    }

    onOrderUpload(product: SelectedProductInterface, files: File[]) {
        this.uploadOrderDocumentsUseCase.bind({ product, documents: files }).subscribe((transaction) => {
            if (transaction.isSuccess) {
                this.getSelectedProducts();
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog, {
                    data: { type: 'info', text: transaction.error },
                });
            }
        });
    }

    onOrderValidate(product: SelectedProductInterface) {
        this.acceptOrderSignatoriesUseCase.bind({ product }).subscribe((transaction) => {
            if (transaction.isSuccess) {
                this.getSelectedProducts();
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog, {
                    data: { text: transaction.error },
                });
            }
        });
    }

    onOrderSign(client: OrderClientInterface, product: SelectedProductInterface) {
        this.continueOrderSignUseCase.bind({ product, client }).subscribe((transaction) => {
            if (transaction.isSuccess) {
                if (transaction.data.xml) {
                    this.loader.addLoader();

                    this.localStorage.step = 8;
                    this.localStorage.write();
                    this.formLogaltyXml = transaction.data.xml;

                    setTimeout(() => {
                        this.parentEvents.resizeLoyalty();
                        (this.formLogalty.nativeElement as HTMLFormElement).submit();
                    });
                }
            } else if (!transaction.isAuthError) {
                this.getSelectedProducts();
                this.dialog.open(ErrorDialog, {
                    data: { text: transaction.error },
                });
            }
        });
    }

    onRememberOrder(client: OrderClientInterface, product: SelectedProductInterface) {
        this.rememberOrderUseCase.bind({ product, client }).subscribe((transaction) => {
            if (transaction.isSuccess) {
                this.getSelectedProducts();
            } else if (!transaction.isAuthError) {
                this.getSelectedProducts();
                this.dialog.open(ErrorDialog, {
                    data: { text: transaction.error },
                });
            }
        });
    }

    onViewDocument(document: OrderDocumentInterface) {
        this.getDocumentContentUseCase.bind({ document }).subscribe((transaction) => {
            if (transaction.isSuccess) {
                FileSaver.saveAs(transaction.data, document.filename);
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog, {
                    data: { text: transaction.error },
                });
            }
        });
    }

    onRemoveDocument(document: OrderDocumentInterface) {
        this.removeDocumentUseCase.bind({ document }).subscribe((transaction) => {
            if (transaction.isSuccess) {
                this.getSelectedProducts();
            } else if (!transaction.isAuthError) {
                this.getSelectedProducts();
                this.dialog.open(ErrorDialog, {
                    data: { text: transaction.error },
                });
            }
        });
    }
}
